import socket from "socket.io-client";

/**
 * 
 * @param {Function} onconnect 
 * @param {Function} ondisconnect 
 * @param {[{event: string, callback: Function}]} events 
 */
export function socket_connect( onconnect, ondisconnect, events ) {
  let _io = socket.connect("http://mdmicroservices.com", {path: "/socket.io"});

  console.log( 'connecting to socket' );
  _io.on( 'connect_error', connect_error_handler );
  _io.on( 'connect_failed', connect_error_handler );
  _io.on( 'error', connect_error_handler );

  if( typeof onconnect === "function" ) {
    _io.on( 'connect', onconnect );
  }

  if( typeof ondisconnect === "function" ) {
    _io.on( 'disconnect', ondisconnect );
  }

  return _io
}

/**
 * 
 * @param {SocketIOClient.Socket} io 
 */
export function socket_disconnect( io ) {
  if( typeof io === "object" && typeof io.disconnect === "function" )
    io.disconnect();
}


function connect_error_handler( error ) {
  console.error(error);
}